/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_Register_Job_ErrorInputs */

const en_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unable to register project sync job: ${i?.message}`)
};

const fr_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible d’enregistrer la tâche de synchronisation du projet : ${i?.message}`)
};

const de_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektsynchronisierungsauftrag konnte nicht registriert werden: ${i?.message}`)
};

const it_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile registrare il processo di sincronizzazione del progetto: ${i?.message}`)
};

const ru_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось зарегистрировать задание синхронизации проекта: ${i?.message}`)
};

const es_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede registrar el trabajo de sincronización del proyecto: ${i?.message}`)
};

const zh_cn2_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法注册项目同步作业：${i?.message}`)
};

const ja_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクト同期ジョブを登録できません: ${i?.message}`)
};

const hi_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक जॉब को पंजीकृत करने में असमर्थ: ${i?.message}`)
};

const pt_pt2_team_sync_register_job_error = /** @type {(inputs: Team_Sync_Register_Job_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível registrar a tarefa de sincronização do projeto: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Unable to register project sync job: {message}" |
*
* @param {Team_Sync_Register_Job_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_register_job_error = /** @type {((inputs: Team_Sync_Register_Job_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Register_Job_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_register_job_error(inputs)
	if (locale === "de") return de_team_sync_register_job_error(inputs)
	if (locale === "it") return it_team_sync_register_job_error(inputs)
	if (locale === "ru") return ru_team_sync_register_job_error(inputs)
	if (locale === "es") return es_team_sync_register_job_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_register_job_error(inputs)
	if (locale === "ja") return ja_team_sync_register_job_error(inputs)
	if (locale === "hi") return hi_team_sync_register_job_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_register_job_error(inputs)
	return en_team_sync_register_job_error(inputs)
});